module.exports = __webpack_public_path__ + "img/OPEN_NEW_TAB.57bdc0d8.svg";